import MxFormCarruselField from "@rf-l2/form/files/MxFormCarruselField";
import { MxFormCarruselFieldProps } from "@rf-l2/form/files/MxFormCarruselField";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";

interface MxFormL3FileCarruselFieldProps<T> extends MxFormCarruselFieldProps<T> {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3FileCarruselField = <T extends any>(
  props: MxFormL3FileCarruselFieldProps<T>
) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormCarruselField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3FileCarruselField;
